<template>
  <div class="typo-small typo-ignore header-bar__button show-for-large">
    <slot></slot>
  </div>
</template>

<script setup></script>
